import { useForm } from 'react-hook-form';
import { Row, Button, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

//icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser } from '@fortawesome/free-solid-svg-icons';

//css
import styles from './LoginForm.module.scss';

import SanitizedInput from '../SanitizedInput';
import usePassword from '../../hooks/usePassword';

const LoginForm = ({ handleLoginFormSubmit, isLogged }) => {
  const { register, handleSubmit } = useForm();
  const { type, Eye } = usePassword();
  const navigate = useNavigate();

  const onSubmit = async (data) => handleLoginFormSubmit(data);

  return (
    <Row className='d-flex d-inline m-auto '>
      <Col xs='11' className='d-none d-lg-block m-auto'>
        <form method='post' className='d-flex d-inline' onSubmit={handleSubmit(onSubmit)}>
          <div className='form-group mx-1'>
            <SanitizedInput
              name='email'
              type='email'
              className='form-control form-control-sm'
              placeholder='Email'
              data-test-id='email'
              register={register}
            />
          </div>

          <div className='form-group mx-1 position-relative'>
            <SanitizedInput
              name='password'
              type={type}
              placeholder='Contraseña'
              className='form-control form-control-sm'
              data-test-id='password'
              max={30}
              register={register}
            />
            <div className='form-group h-100 pe-1 d-flex gap-2 position-absolute end-0 top-0'>
              <Eye className='p-0' />
              <a
                onClick={() => navigate(`/forgot-password`)}
                className={`${styles.forgotPassword} mt-auto mb-auto`}
              >
                ¿Olvidó?
              </a>
            </div>
          </div>

          <Button type='submit' className='btn btn-sm btn-danger mx-1 text-nowrap'>
            Iniciar Sesión
          </Button>

          <Link className='btn btn-sm btn-secondary' to='/home/registracion'>
            Regístrese
          </Link>
        </form>
      </Col>
      {!isLogged ? (
        <Col lg='1' xs='5' className='d-lg-none d-sm-block mr-2' title='Login'>
          <Button className='btn btn-sm btn-dark ' title='Home'>
            <Link to='/login-mobile'>
              <FontAwesomeIcon className='text-white' size='2x' icon={faUser} />
            </Link>
          </Button>
        </Col>
      ) : null}
      <Col lg='1' xs='5'>
        <Button className='btn btn-sm btn-dark' title='Home'>
          <Link to='/'>
            <FontAwesomeIcon className='text-white' size='2x' icon={faHome} />
          </Link>
        </Button>
      </Col>
    </Row>
  );
};

export default LoginForm;
